import React from "react";

const ScorePlusForm = ({ form, updateForm, onSubmit, onCancel }) => {
  const focusOptions = [
    { emoji: "🎓", label: "Learning" },
    { emoji: "💼", label: "Career" },
    { emoji: "🧠", label: "Discipline" },
    { emoji: "💪", label: "Health" },
    { emoji: "⚽", label: "Sports" },
    { emoji: "🚀", label: "Build" },
    { emoji: "📈", label: "Productivity" },
    { emoji: "🎯", label: "Focus" },

    { emoji: "👀", label: "Attention" },
    { emoji: "❤️", label: "Connection" },
    { emoji: "😊", label: "Emotional Regulation" },
    { emoji: "📋", label: "Routine" },
    { emoji: "🏃", label: "Movement" },
    { emoji: "😴", label: "Sleep" },
    { emoji: "🌟", label: "Confidence" },
    { emoji: "🎬", label: "Entertainment" },

    { emoji: "🧘", label: "Mindfulness" },
    { emoji: "🎨", label: "Creativity" },
    { emoji: "🤝", label: "Relationships" },
    { emoji: "🏢", label: "Entrepreneurship" },
    { emoji: "💰", label: "Financial" },
    { emoji: "👑", label: "Leadership" },

    { emoji: "🤰", label: "MaternityCare" }, // AnvayaEhsaas
    { emoji: "🌱", label: "ChildGrowth" }, // AnvayaGrowth
    { emoji: "🩸", label: "BalanceDiabetes" }, // Balance
    { emoji: "❤️‍🔥", label: "VitalCardio" }, // Vital
    { emoji: "🌸", label: "HerLifeW30+" }, // HerLife
    { emoji: "🫁", label: "Breathe" }, // Breathe
    { emoji: "🌿", label: "Sahara60+" }, // Sahara
    { emoji: "🫘", label: "RenaLife" }, // Renalife
    { emoji: "🧠", label: "NeuroLife" }, // Neurolife
    { emoji: "💓", label: "RhythmThyro" }, // Rythm
    { emoji: "🌈", label: "ThriveGeneral" }, // Thrive
    { emoji: "✨", label: "VibeYouthHealth" }, // Vibe
    { emoji: "🕊️", label: "Udaan518Health" }, // Udaan
    { emoji: "🎗️", label: "HopeLifeOnco" }, // Hopelife
    { emoji: "🦶", label: "PodiaFootHealth" }, // Podialife
  ];

  return (
    <div className="bg-zinc-900 rounded-xl border border-zinc-700 p-4">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-2">
        <div>
          <label className="block text-xs text-gray-200 mb-1">Focus</label>

          <select
            value={form.act}
            onChange={(e) => updateForm("act", e.target.value)}
            className="w-full bg-zinc-800 border border-zinc-700 rounded-lg px-2 py-1 text-white"
          >
            <option value="">Select Focus</option>

            {focusOptions.map((item) => (
              <option key={item.label} value={item.label}>
                {item.emoji} {item.label}
              </option>
            ))}
          </select>
        </div>
        <div className="flex flex-col w-full">
          <label className="text-xs text-gray-200">Activity</label>

          <input
            type="text"
            value={form.activity}
            onChange={(e) => updateForm("activity", e.target.value)}
            className="block w-full mt-1 bg-zinc-800 border border-zinc-700 rounded-lg px-2 py-1 text-white"
          />
        </div>

        <div>
          <label className="text-xs text-gray-200">Date</label>

          <input
            type="date"
            value={form.date}
            onChange={(e) => updateForm("date", e.target.value)}
            className="w-full mt-1 bg-zinc-800 border border-zinc-700 rounded-lg px-2 py-1 text-white"
          />
        </div>

        <div>
          <label className="text-xs text-gray-200">Status</label>

          <select
            value={form.status}
            onChange={(e) => updateForm("status", e.target.value)}
            className="w-full mt-1 bg-zinc-800 border border-zinc-700 rounded-lg px-2 py-1 text-white"
          >
            <option>Done</option>
            <option>Not Done</option>
          </select>
        </div>

        {form.status === "Done" && (
          <>
            <div>
              <label className="text-xs text-gray-200">Start Time</label>

              <input
                type="time"
                value={form.startTime}
                onChange={(e) => updateForm("startTime", e.target.value)}
                className="w-full mt-1 bg-zinc-800 border border-zinc-700 rounded-lg px-2 py-1 text-white"
              />
            </div>

            <div>
              <label className="text-xs text-gray-200">Duration</label>

              <input
                type="number"
                value={form.duration}
                onChange={(e) => updateForm("duration", e.target.value)}
                className="w-full mt-1 bg-zinc-800 border border-zinc-700 rounded-lg px-2 py-1 text-white"
              />
            </div>

            <div>
              <label className="text-xs text-gray-200">Unit</label>
              <select
                value={form.durationUnit}
                onChange={(e) => updateForm("durationUnit", e.target.value)}
                className="w-full mt-1 bg-zinc-800 border border-zinc-700 rounded-lg px-2 py-1 text-white"
              >
                <option>Sec</option>
                <option>Min</option>
                <option>Hr</option>
                <option>Times</option>
              </select>
            </div>
          </>
        )}
      </div>

      <div className="flex flex-col lg:flex-row gap-2">
        <div className="flex flex-col w-full">
          <label className="text-xs text-gray-200">Expert</label>

          <input
            type="text"
            value={form.viewerCode1}
            onChange={(e) => updateForm("viewerCode1", e.target.value)}
            className="block w-full mt-1 bg-zinc-800 border border-zinc-700 rounded-lg px-2 py-1 text-white"
          />
        </div>

        <div className="flex flex-col w-full">
          <label className="text-xs text-gray-200">Companny</label>

          <input
            type="text"
            value={form.viewerCode2}
            onChange={(e) => updateForm("viewerCode2", e.target.value)}
            className="block w-full mt-1 bg-zinc-800 border border-zinc-700 rounded-lg px-2 py-1 text-white"
          />
        </div>
      </div>

      <div className="flex flex-col w-full">
        <label className="text-xs text-gray-200">Tags (comma separated)</label>

        <input
          type="text"
          value={form.tags}
          onChange={(e) => updateForm("tags", e.target.value)}
          className="block w-full mt-1 bg-zinc-800 border border-zinc-700 rounded-lg px-2 py-1 text-white"
        />
      </div>

      <div className="mt-4">
        <button
          onClick={onSubmit}
          className="w-fit px-5 py-1 rounded-lg bg-cyan-500 text-black font-semibold"
        >
          {form._id ? "Update" : "Create"}
        </button>
        {form._id && (
          <button
            onClick={onCancel}
            className="ml-3 w-fit px-5 py-1 rounded-lg bg-zinc-700 text-white"
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  );
};

export default ScorePlusForm;
